import React, { useEffect } from 'react';
import {
  LightboxOverlay,
  LightboxImg,
  LightboxClose,
  LightboxFileName,
} from './files-drawer.styled';
import { useBackHandler } from '../../../platform/use-back-handler';

type Props = {
  open: boolean;
  onClose: () => void;
  imageUrl: string | null;
  fileName: string;
};

export const ImageLightbox: React.FC<Props> = ({ open, onClose, imageUrl, fileName }) => {
  useBackHandler('lightbox', open, onClose);

  // Close on Escape key
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !imageUrl) return null;

  return (
    <LightboxOverlay
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <LightboxClose onMouseDown={(e) => e.stopPropagation()} onClick={onClose} aria-label="Close">
        &#x2715;
      </LightboxClose>
      <LightboxImg
        src={imageUrl}
        alt={fileName}
        onMouseDown={(e) => e.stopPropagation()}
      />
      <LightboxFileName onMouseDown={(e) => e.stopPropagation()}>{fileName}</LightboxFileName>
    </LightboxOverlay>
  );
};
